import React, { useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import TooltipCleaner from "./TooltipCleaner";  // Import the TooltipCleaner component
import { useTranslation } from 'react-i18next'; // Import hook
import Footer from './Footer.js';
import { BtcPriceContext } from './BtcPriceContext';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);
  useLayoutEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}
const HomePage = React.lazy(() => import('./HomePage.js'));
const NotFound = React.lazy(() => import('./404'));
const Forbidden = React.lazy(() => import('./403'));
const PolitikaZasebnostiPage = React.lazy(() => import('./Politika_zasebnosti.js'));
const PolitikaPiskotkovPage = React.lazy(() => import('./Politika_piskotkov.js'));
const PogojiUporabePage = React.lazy(() => import('./Pogoji_uporabe.js'));
const EURBTCPage = React.lazy(() => import('./EURBTCPage.js'));
const MaleCeneRizBeliPage = React.lazy(() => import('./Male_cene_riz_beli.js'));
const MaleCeneHruhPage = React.lazy(() => import('./Male_cene_kruh.js'));
const TesteninePage = React.lazy(() => import('./Male_cene_testenine.js'));
const MesoPage = React.lazy(() => import('./Male_cene_meso.js'));
const MlekoPage = React.lazy(() => import('./Male_cene_mleko.js'));
const JajcaPage = React.lazy(() => import('./Male_cene_jajca.js'));
const MasloPage = React.lazy(() => import('./Male_cene_maslo.js'));
const JabolkaPage = React.lazy(() => import('./Male_cene_jabolka.js'));
const BananePage = React.lazy(() => import('./Male_cene_banane.js'));
const ParadiznikPage = React.lazy(() => import('./Male_cene_paradiznik.js'));
const CebulaPage = React.lazy(() => import('./Male_cene_cebula.js'));
const KrompirPage = React.lazy(() => import('./Male_cene_krompir.js'));
const SladkorPage = React.lazy(() => import('./Male_cene_sladkor.js'));
const KisPage = React.lazy(() => import('./Male_cene_kis.js'));
const SolPage = React.lazy(() => import('./Male_cene_sol.js'));
const KavaPage = React.lazy(() => import('./Male_cene_kava.js'));
const ZganjePage = React.lazy(() => import('./Male_cene_zganje.js'));
const MoskaOblekaPage = React.lazy(() => import('./Male_cene_moska_obleka.js'));
const MoskaSrajcaPage = React.lazy(() => import('./Male_cene_moska_srajca.js'));
const ZenskaBluzaPage = React.lazy(() => import('./Male_cene_zenska_bluza.js'));
const OtroskaMajicaPage = React.lazy(() => import('./Male_cene_otroska_majica.js'));
const ZemeljskiPlinPage = React.lazy(() => import('./Male_cene_zemeljski_plin.js'));
const KurilnoOljePage = React.lazy(() => import('./Male_cene_kurilno_olje.js'));
const ElektrikaPage = React.lazy(() => import('./Male_cene_elektrika.js'));
const PralniStrojPage = React.lazy(() => import('./Male_cene_pralni_stroj.js'));
const LikalnikPage = React.lazy(() => import('./Male_cene_likalnik.js'));
const PriborPage = React.lazy(() => import('./Male_cene_pribor.js'));
const PonevPage = React.lazy(() => import('./Male_cene_ponev.js'));
const KosilnicaPage = React.lazy(() => import('./Male_cene_kosilnica.js'));
const PralniPrasekPage = React.lazy(() => import('./Male_cene_pralni_prasek.js'));
const TekociDetergentPage = React.lazy(() => import('./Male_cene_tekoci_detergent.js'));
const AspirinPage = React.lazy(() => import('./Male_cene_aspirin.js'));
const RupurutPage = React.lazy(() => import('./Male_cene_rupurut.js'));
const SirupKaseljPage = React.lazy(() => import('./Male_cene_sirup_kaselj.js'));
const VitaminCPage = React.lazy(() => import('./Male_cene_vitamin_c.js'));
const RenaultClioPage = React.lazy(() => import('./Male_cene_renault_clio.js'));
const VWPoloPage = React.lazy(() => import('./Male_cene_vw_polo.js'));
const KoloPage = React.lazy(() => import('./Male_cene_kolo.js'));
const DieselGorivoPage = React.lazy(() => import('./Male_cene_diesel_gorivo.js'));
const BencinPage = React.lazy(() => import('./Male_cene_bencin.js'));
const TehnicniPregledPage = React.lazy(() => import('./Male_cene_tehnicni_pregled.js'));
const MestniAvtobusPage = React.lazy(() => import('./Male_cene_mestni_avtobus.js'));
const PrevozTaksiPage = React.lazy(() => import('./Male_cene_prevoz_taksi.js'));
const PostninaPage = React.lazy(() => import('./Male_cene_postnina.js'));
const FitnesPage = React.lazy(() => import('./Male_cene_fitnes.js'));
const KinoPage = React.lazy(() => import('./Male_cene_kino.js'));
const GledaliscePage = React.lazy(() => import('./Male_cene_gledalisce.js'));
const CasopisPage = React.lazy(() => import('./Male_cene_casopis.js'));
const SolskiZvezekPage = React.lazy(() => import('./Male_cene_solski_zvezek.js'));
const SvincnikPage = React.lazy(() => import('./Male_cene_svincnik.js'));
const TestenineOmakaPage = React.lazy(() => import('./Male_cene_testenine_omaka.js'));
const MeniKosiloPage = React.lazy(() => import('./Male_cene_meni_kosilo.js'));
const PicaPage = React.lazy(() => import('./Male_cene_pica.js'));
const PalacinkePage = React.lazy(() => import('./Male_cene_palacinke.js'));
const CocaColaPage = React.lazy(() => import('./Male_cene_coca_cola.js'));
const EspressoPage = React.lazy(() => import('./Male_cene_espresso.js'));
const NocitevHotelPage = React.lazy(() => import('./Male_cene_nocitev_hotel.js'));
const MoskoStrizenjePage = React.lazy(() => import('./Male_cene_mosko_strizenje.js'));
const ZenskoStrizenjePage = React.lazy(() => import('./Male_cene_zensko_strizenje.js'));
const OtroskePlenicePage = React.lazy(() => import('./Male_cene_otroske_plenice.js'));
const PogrebPage = React.lazy(() => import('./Male_cene_pogreb.js'));
const NepremicnineNovaStanovanjaSlovenijaPage = React.lazy(() => import('./Nepremicnine_nova_stanovanja_slovenija.js'));
const NepremicnineRabljenaStanovanjaSlovenijaPage = React.lazy(() => import('./Nepremicnine_rabljena_stanovanja_slovenija.js'));
const NepremicnineRabljenaStanovanjaLjubljanaPage = React.lazy(() => import('./Nepremicnine_rabljena_stanovanja_ljubljana.js'));
const NepremicnineRabljenaStanovanjaMariborPage = React.lazy(() => import('./Nepremicnine_rabljena_stanovanja_maribor.js'));
const NepremicnineHisePage = React.lazy(() => import('./Nepremicnine_hise.js'));
const NetoPlacePage = React.lazy(() => import('./Neto_place.js'));
const BrutoDomaciProizvodPage = React.lazy(() => import('./Bruto_domaci_proizvod.js'));
const JavniDolgPage = React.lazy(() => import('./Javni_dolg.js'));
const ZlatoPage = React.lazy(() => import('./Zlato.js'));
const SrebroPage = React.lazy(() => import('./Srebro.js'));
const PragTveganjaRevscinePage = React.lazy(() => import('./Prag_tveganja_revscine.js'));
const KalkulatorjiPage = React.lazy(() => import('./KalkulatorjiPage.js'));
const KalkulatorBtcEur = React.lazy(() => import('./KalkulatorBtcEur.js'));
const KalkulatorZgodovinskeCene = React.lazy(() => import('./KalkulatorZgodovinskeCene.js'));

function App() {
  const [latestPrice, setLatestPrice] = useState(null);	
  const { t, i18n } = useTranslation(); // `t` is the translation function, `i18n` provides language management

  // Get the language from localStorage (if available) or default to 'sl'
  const savedLanguage = localStorage.getItem('language') || 'sl';

  // Set the language in i18n based on saved language
  useEffect(() => {
    i18n.changeLanguage(savedLanguage);
  }, [savedLanguage, i18n]);

  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);  // Change language dynamically
    localStorage.setItem('language', lang);  // Save the selected language in localStorage
  };

  useEffect(() => {
  const fetchLatestBTCPrice = async () => {
    try {
      const response = await fetch("/api/getBTCData");
      const data = await response.json();
      if (data && data.length > 0) {
        const latestEntry = data[data.length - 1];
        setLatestPrice(latestEntry.priceBTCtoEUR);
      }
    } catch (error) {
      console.error("Error fetching BTC data from external source:", error);
    }
  };

  fetchLatestBTCPrice();
}, []);

  return (
    <BtcPriceContext.Provider value={latestPrice}>
    <HelmetProvider>
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <TooltipCleaner />
        <nav className="navbar">
			<div className="navbar-container">
			<div className="navbar-left">
				<a href="/">
					<img
						src={`${process.env.PUBLIC_URL}/Logo1.svg`}
						alt="Logo"
						className="navbar-logo"
					/>
				</a>
			</div>
			<div className="navbar-right">
              {latestPrice && (
                <div className="btc-price" title={t('btc_price_tooltip')}>
                  <span>BTCEUR: €{latestPrice.toLocaleString('sl-SI')}</span>
                </div>
              )}
              {/* Flag icons for language switching */}
              <img
                src={`${process.env.PUBLIC_URL}/slovenian-flag.png`}
                alt="Slovenian"
                className="flag-icon"
                onClick={() => switchLanguage('sl')}
              />
              <img
                src={`${process.env.PUBLIC_URL}/english-flag.png`}
                alt="English"
                className="flag-icon"
                onClick={() => switchLanguage('en')}
              />
            </div>
		</div>
        </nav>
        <div className="container">
          <React.Suspense fallback={<p className="loading">Nalagam...</p>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
			<Route path="/forbidden" element={<Forbidden />} />
			<Route path="/politika-zasebnosti" element={<PolitikaZasebnostiPage />} />
			<Route path="/politika-piskotkov" element={<PolitikaPiskotkovPage />} />
			<Route path="/pogoji-uporabe" element={<PogojiUporabePage />} />
            <Route path="/eur-btc" element={<EURBTCPage />} />
            <Route path="/hrana-pijaca/riz-beli" element={<MaleCeneRizBeliPage />} />
            <Route path="/hrana-pijaca/kruh" element={<MaleCeneHruhPage />} />
            <Route path="/hrana-pijaca/testenine" element={<TesteninePage />} />
            <Route path="/hrana-pijaca/meso" element={<MesoPage />} />
            <Route path="/hrana-pijaca/mleko" element={<MlekoPage />} />
            <Route path="/hrana-pijaca/jajca" element={<JajcaPage />} />
            <Route path="/hrana-pijaca/maslo" element={<MasloPage />} />
            <Route path="/hrana-pijaca/jabolka" element={<JabolkaPage />} />
            <Route path="/hrana-pijaca/banane" element={<BananePage />} />
            <Route path="/hrana-pijaca/paradiznik" element={<ParadiznikPage />} />
            <Route path="/hrana-pijaca/cebula" element={<CebulaPage />} />
            <Route path="/hrana-pijaca/krompir" element={<KrompirPage />} />
            <Route path="/hrana-pijaca/sladkor" element={<SladkorPage />} />
            <Route path="/hrana-pijaca/kis" element={<KisPage />} />
            <Route path="/hrana-pijaca/sol" element={<SolPage />} />
            <Route path="/hrana-pijaca/kava" element={<KavaPage />} />
            <Route path="/hrana-pijaca/zganje" element={<ZganjePage />} />
            <Route path="/izdelki/moska-obleka" element={<MoskaOblekaPage />} />
            <Route path="/izdelki/moska-srajca" element={<MoskaSrajcaPage />} />
            <Route path="/izdelki/zenska-bluza" element={<ZenskaBluzaPage />} />
			<Route path="/izdelki/otroska-majica" element={<OtroskaMajicaPage />} />
			<Route path="/izdelki/pralni-stroj" element={<PralniStrojPage />} />
			<Route path="/izdelki/likalnik" element={<LikalnikPage />} />
			<Route path="/izdelki/pribor" element={<PriborPage />} />
			<Route path="/izdelki/ponev" element={<PonevPage />} />
			<Route path="/izdelki/kosilnica" element={<KosilnicaPage />} />
			<Route path="/izdelki/pralni-prasek" element={<PralniPrasekPage />} />
			<Route path="/izdelki/tekoci-detergent" element={<TekociDetergentPage />} />
			<Route path="/izdelki/renault-clio" element={<RenaultClioPage />} />
			<Route path="/izdelki/vw-polo" element={<VWPoloPage />} />
			<Route path="/izdelki/kolo" element={<KoloPage />} />
			<Route path="/izdelki/casopis" element={<CasopisPage />} />
			<Route path="/izdelki/solski-zvezek" element={<SolskiZvezekPage />} />
			<Route path="/izdelki/svincnik" element={<SvincnikPage />} />
			<Route path="/izdelki/otroske-plenice" element={<OtroskePlenicePage />} />
			<Route path="/zdravila/aspirin" element={<AspirinPage />} />
			<Route path="/zdravila/rupurut" element={<RupurutPage />} />
			<Route path="/zdravila/sirup-kaselj" element={<SirupKaseljPage />} />
			<Route path="/zdravila/vitamin-c" element={<VitaminCPage />} />
			<Route path="/energija/diesel-gorivo" element={<DieselGorivoPage />} />
			<Route path="/energija/bencin" element={<BencinPage />} />
			<Route path="/energija/zemeljski-plin" element={<ZemeljskiPlinPage />} />
			<Route path="/energija/kurilno-olje" element={<KurilnoOljePage />} />
			<Route path="/energija/elektrika" element={<ElektrikaPage />} />
			<Route path="/storitev/tehnicni-pregled" element={<TehnicniPregledPage />} />
			<Route path="/storitev/mestni-avtobus" element={<MestniAvtobusPage />} />
			<Route path="/storitev/prevoz-taksi" element={<PrevozTaksiPage />} />
			<Route path="/storitev/postnina" element={<PostninaPage />} />
			<Route path="/storitev/fitnes" element={<FitnesPage />} />
			<Route path="/storitev/kino" element={<KinoPage />} />
			<Route path="/storitev/gledalisce" element={<GledaliscePage />} />
			<Route path="/storitev/nocitev-hotel" element={<NocitevHotelPage />} />
			<Route path="/storitev/mosko-strizenje" element={<MoskoStrizenjePage />} />
			<Route path="/storitev/zensko-strizenje" element={<ZenskoStrizenjePage />} />
			<Route path="/storitev/pogreb" element={<PogrebPage />} />
			<Route path="/restavracija/testenine-omaka" element={<TestenineOmakaPage />} />
			<Route path="/restavracija/meni-kosilo" element={<MeniKosiloPage />} />
			<Route path="/restavracija/pica" element={<PicaPage />} />
			<Route path="/restavracija/palacinke" element={<PalacinkePage />} />
			<Route path="/restavracija/coca-cola" element={<CocaColaPage />} />
			<Route path="/restavracija/espresso" element={<EspressoPage />} />
			<Route path="/nepremicnine/nova-stanovanja-slovenija" element={<NepremicnineNovaStanovanjaSlovenijaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-slovenija" element={<NepremicnineRabljenaStanovanjaSlovenijaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-ljubljana" element={<NepremicnineRabljenaStanovanjaLjubljanaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-maribor" element={<NepremicnineRabljenaStanovanjaMariborPage />} />
			<Route path="/nepremicnine/hise" element={<NepremicnineHisePage />} />
			<Route path="/neto-place" element={<NetoPlacePage />} />
			<Route path="/bruto-domaci-proizvod" element={<BrutoDomaciProizvodPage />} />
			<Route path="/javni-dolg" element={<JavniDolgPage />} />
			<Route path="/zlato-btc" element={<ZlatoPage />} />
			<Route path="/srebro-btc" element={<SrebroPage />} />
			<Route path="/prag-tveganja-revscine" element={<PragTveganjaRevscinePage />} />
			<Route path="/kalkulatorji" element={<KalkulatorjiPage />} />
			<Route path="/kalkulator/btc-eur" element={<KalkulatorBtcEur />} />
			<Route path="/kalkulator/zgodovinske-cene" element={<KalkulatorZgodovinskeCene />} />
			<Route path="*" element={<NotFound />} />
          </Routes>
          </React.Suspense>
        </div>
		<Footer /> {/* Add Footer here */}
      </div>
    </Router>
    </HelmetProvider>
    </BtcPriceContext.Provider>
  );
}

export default App;